/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SwimlaneCompanyTeam } from './swimlaneCompanyTeam';


export interface WorkflowTeam { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    workflowId: string;
    numberOfSwimlane: number;
    swimlanes?: Array<SwimlaneCompanyTeam>;
}

